<template>
  <!-- eslint-disable max-len -->
  <div
    class="absolute error error-box rounded-input text-red text-4 bg-gray py-error px-2 z-50 text-center w-fit pointer-events-none"
    :class="{ 'opacity-0': !visible }"
    :style="position"
  >
    <CoreIcon
      class="h-3 inline mr-2"
      icon="exclamation"
    /><span
      class="text-red"
      v-text="delayedMessage"
    />
  </div>
</template>

<script>
export default {
  name: 'CoreError',

  props: {
    message: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    position: {
      // Aim for 0.25rem gap to preceding element
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    delayedMessage: '',
  }),

  watch: {
    message: {
      immediate: true,
      handler(val) {
        if (val === '') {
          setTimeout(() => { this.delayedMessage = this.message; }, 250);
        } else {
          this.delayedMessage = this.message;
        }
      },
    },
  },
};
</script>

<style scoped>
.py-error {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.error {
  border: 2px solid theme(colors.red);
}

.error-box {
  transition-property: opacity;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease);
}
</style>
